module.exports = __webpack_public_path__ + "img/level_1.c586baee.svg";